import TagManager from "react-gtm-module";

const {REACT_APP_GAPP_ID} = process.env;
export const sendDataLayer = (content, {context = null, location = null}, clear = true) => {
    if (!REACT_APP_GAPP_ID) return false;
    let cleanedContent = Object.assign({}, content);
    for (let key in cleanedContent) {
        if (key !== "event") cleanedContent[key] = undefined;
    }
    if (clear) sendDataLayer({...cleanedContent, event: "cleaning_datalayer"}, {context, location}, false);
    let tagManagerArgs = {
        gtmId: REACT_APP_GAPP_ID,
        dataLayer: null,
        dataLayerName: "PageDataLayer",
    };
    tagManagerArgs.dataLayer = {
        ...{
            user_id: context?.credential?.credential_id || null,
            current_company: context?.company_id || null,
        },
        ...content,
    };
    if (location && location.pathname) {
        tagManagerArgs.dataLayer = {
            page: location.pathname,
        };
    }
    TagManager.dataLayer(tagManagerArgs);
    if (clear) sendDataLayer({...cleanedContent, event: "cleaning_datalayer"}, {context, location}, false);
    return true;
};
